export const getNestedProperty = (
  propertyPath: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  object: Record<string, any>
) => {
  const keys = propertyPath.split(".");
  let current = object;

  for (const key of keys) {
    // 1. Explicitly block runtime prototype keys
    if (key === "__proto__" || key === "constructor" || key === "prototype") {
      return undefined;
    }

    // 2. Strict type check and direct ownership verification
    if (
      !current ||
      typeof current !== "object" ||
      !Object.prototype.hasOwnProperty.call(current, key)
    ) {
      return undefined;
    }

    // nosemgrep: javascript.lang.security.audit.prototype-pollution.prototype-pollution-loop.prototype-pollution-loop
    current = current[key];
  }

  return current;
};

export const merge = <T extends Record<string, unknown>>(
  obj1: T,
  obj2: T
): T => {
  const result: Record<string, unknown> = { ...obj1 };

  for (const key in obj2) {
    if (obj2[key] !== undefined) {
      if (
        typeof obj2[key] === "object" &&
        obj2[key] !== null &&
        !Array.isArray(obj2[key])
      ) {
        result[key] = merge(obj1[key] as T, obj2[key] as T);
      } else {
        result[key] = obj2[key];
      }
    }
  }

  return result as T;
};

export const mapLabelWithFallback = <T>(
  key: keyof T,
  value: string | null,
  labelMappings: Record<string, string>,
  fallbacks: Partial<Record<keyof T, string>>
) => {
  const label = value && labelMappings[value as string];

  return label || fallbacks[key] || null;
};
